import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { EbsWebService } from "../../services/ebsWebService";
import { AfterViewInit } from '@angular/core'

import { Chart } from 'chart.js';

@Component({
  selector: 'page-chart',
  templateUrl: 'chartpage.html',
})
export class ChartPage implements AfterViewInit {

  options: Object;
  innerHeight: any;
  innerWidth: any;
  myChart: any;
  chartTitle: string = "Chart";
  chartSubtitle: string = "";

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    private _ebsWebService: EbsWebService) {
  }

  ngAfterViewInit(): void {
    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.navParams.get('postParams'));
    this._ebsWebService.postData(this.navParams.get('actionURL'), postPayloadObject).subscribe(res => {
      console.log(res);
      let chartType;
      if (res.Dynamic.ChartType != undefined && res.Dynamic.ChartType != "") {
        chartType = res.Dynamic.ChartType;
      }
      if (chartType == undefined) {
        console.error('Chart type is not defined!!!!');
      }
      switch (chartType) {
        case 'Line':
          this.drawLineChart(res);
          break;
        case 'Bar':
          this.drawBarChart(res);
          break;
        case 'Pie':
          this.drawPieChart(res);
          break;
        default:
          console.error('Chart type is not supported!');
          break;
      }
    });
  }

  drawLineChart(res) {
    // todo implement
  }

  drawBarChart(res) {
    let seriesData = [];
    let xAxisLabels = [];
    let xAxisTitle = "";
    let yAxisTitle = "";
    let stacking = false;
    for (let i = 0; i < res.ListItemNavigation.length; i++) {
      let item = res.ListItemNavigation[i];
      let legend = item.ListItemContent.filter(j => j.FieldName == "legend")[0].DisplayText;
      let x = item.ListItemContent.filter(j => j.FieldName == "x")[0].DisplayText;
      let filtered = seriesData.filter(a => a.label == legend);
      if (filtered.length == 0) {
        let color = '#' + Math.floor(Math.random() * 16777215).toString(16);
        seriesData.push({ label: legend, data: [], backgroundColor: color || 'blue' });
      }
      if (xAxisLabels.filter(a => a == x).length == 0) {
        xAxisLabels.push(x);
      }
    }

    for (let i = 0; i < res.ListItemNavigation.length; i++) {
      let item = res.ListItemNavigation[i];
      let data = {
        x: item.ListItemContent.filter(j => j.FieldName == "x")[0].DisplayText,
        val: parseFloat(item.ListItemContent.filter(j => j.FieldName == "val")[0].DisplayText.replace(',', '.')),
        legend: item.ListItemContent.filter(j => j.FieldName == "legend")[0].DisplayText
      }
      for (let j = 0; j < seriesData.length; j++) {
        let series = seriesData[j];
        if (series.label == data.legend) {
          series.data.push(data.val);
        }
      }
    }
    console.log(seriesData);

    if (typeof res.Dynamic != "undefined" && typeof res.Dynamic != null) {
      if (res.Dynamic.ChartTitle != undefined && res.Dynamic.ChartTitle != "") {
        this.chartTitle = res.Dynamic.ChartTitle;
      }
      if (res.Dynamic.ChartSubtitle != undefined && res.Dynamic.ChartSubtitle != "") {
        this.chartSubtitle = res.Dynamic.ChartSubtitle;
      }
      if (res.Dynamic.ChartXAxisTitle != undefined && res.Dynamic.ChartXAxisTitle != "") {
        xAxisTitle = res.Dynamic.ChartXAxisTitle;
      }
      if (res.Dynamic.ChartYAxisTitle != undefined && res.Dynamic.ChartYAxisTitle != "") {
        yAxisTitle = res.Dynamic.ChartYAxisTitle;
      }
      if (res.Dynamic.Stacking != undefined && res.Dynamic.Stacking != "") {
        stacking = res.Dynamic.Stacking == "true" ? true : false;
      }
    }

    console.log(stacking);

    var ctx = document.getElementById('myChart');
    var data = {
      labels: xAxisLabels,
      datasets: seriesData
    };

    this.myChart = new Chart(ctx, {
      type: 'bar',
      data: data,
      options: {
        barValueSpacing: 20,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: stacking,
            scaleLabel: {
              display: true,
              labelString: xAxisTitle
            }
          }],
          yAxes: [{
            stacked: stacking,
            scaleLabel: {
              display: true,
              labelString: yAxisTitle
            }
          }]
        },
        plugins: {
          zoom: {
            zoom: {
              enabled: true,
              mode: 'xy'
            },
            pan: {
              enabled: true
            }
          }
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return ` ${data.labels[tooltipItem.index]}: ${this.numberWithCommas(value)}`;
            }
          }
        }
      }
    });

  }

  drawPieChart(res) {
    let seriesData = [];
    let seriesLabels = [];
    let backgroundColors = [];
    for (let i = 0; i < res.ListItemNavigation.length; i++) {
      let item = res.ListItemNavigation[i];
      seriesData.push(parseFloat(item.ListItemContent.filter(j => j.FieldName == "val")[0].DisplayText));
      seriesLabels.push(item.ListItemContent.filter(j => j.FieldName == "legend")[0].DisplayText);
      backgroundColors.push('#' + Math.floor(Math.random() * 16777215).toString(16));
    }

    if (typeof res.Dynamic != "undefined" && typeof res.Dynamic != null) {
      if (res.Dynamic.ChartTitle != undefined && res.Dynamic.ChartTitle != "") {
        this.chartTitle = res.Dynamic.ChartTitle;
      }
      if (res.Dynamic.ChartSubtitle != undefined && res.Dynamic.ChartSubtitle != "") {
        this.chartSubtitle = res.Dynamic.ChartSubtitle;
      }
      if (res.Dynamic.ChartColors != undefined && res.Dynamic.ChartColors != "") {
        backgroundColors = JSON.parse(res.Dynamic.ChartColors);
      }
    }

    var ctx = document.getElementById('myChart');
    var data = {
      labels: seriesLabels,
      datasets: [{
        data: seriesData,
        backgroundColor: backgroundColors,
        hoverOffset: 4
      }]
    };

    this.myChart = new Chart(ctx, {
      type: 'pie',
      data: data,
      options: {
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return ` ${data.labels[tooltipItem.index]}: ${this.numberWithCommas(value)}`;
            }
          }
        }
      }
    });

  }

  numberWithCommas(num) {
    return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); // thousand point and komma, rounded to 2 digits
  }

  downloadChart() {
    let base64 = this.myChart.toBase64Image('image/png', 1)
    let a = document.createElement("a");
    a.href = base64;
    a.download = "chart.png";
    a.click();
  }

}



// WEBPACK FOOTER //
// ./src/pages/chartpage/chartpage.ts